
import { useState } from 'react'
import { booking_filter_keys, modalEnum, TableController } from '../../../components/Constant'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

import moment from 'moment-timezone'
import { EVENT_BOOKING_LIST } from '../../../repository/vendor_management_repo'
import useReduxStore from '../../../hooks/useReduxStore'


export default function useTickets() {

    const { t } = useTranslation()
    const [controller, setController] = useState(TableController)
    const [totalCount, setTotalCount] = useState(0)
    const [filtermodal, setFiltermodal] = useState(modalEnum)
    const [loader, setLoader] = useState(false)
    const [bookingList, setBookingList] = useState([])
    const [Filter, setFilter] = useState(booking_filter_keys)
    const [openModal, setOpenModal] = useState({ view: false, data: null })

    const { selector: user } = useReduxStore("auth")

    const TableHeaderData = [
        { label: '#' },
        { label: `${t('tableTitle.bookingReferenceNumber')}` },
        { label: `${t('tableTitle.eventName')}` },
        { label: `${t('tableTitle.clientName')}` },
        // { label: `${t('tableTitle.quantity')}` },
        { label: `${t('tableTitle.booking_Date_Time')}` },
        { label: `${t('tableTitle.price')} (${t("tableTitle.currencysymbols")})` },
    ]


    useEffect(() => {
        getBookingList()
    }, [controller])

    const getBookingList = async () => {
        setLoader(true)
        const payload = {
            vendorId: user?.userInfo?._id,
            page: controller?.page,
            count: controller?.rowsPerPage,
            searchText: Filter?.search,
            startDate: Filter?.startDate ? moment(Filter?.startDate).format("YYYY-MM-DD") : null,
            endDate: Filter?.endDate ? moment(Filter?.endDate).format("YYYY-MM-DD") : null,
        }
        try {
            let response = await EVENT_BOOKING_LIST(payload)
            setBookingList(response?.data)
            setTotalCount(response?.totalCount)
            setLoader(false)
        } catch (error) {
            setBookingList([])
            setTotalCount(0)
            setLoader(false)
        }
    }

    const handleClickFilter = () => {

        setFiltermodal((pre) => ({ ...pre, open: !pre?.open }))
    }

    const handleChangeFilter = (event, disable = false) => {
        const { name, value, checked } = event.target
        if (name === "status") {
            setFilter((pre) => ({
                ...pre, disable_button: disable,
                status: checked ? [...pre.status, value] : pre?.status?.filter((cur) => cur !== value)
            }))
        } else {
            setFilter((pre) => ({ ...pre, disable_button: disable, [name]: value }))
        }
    }
    const HandleSearch = ({ filterPopup }) => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
        if (filterPopup) handleClickFilter()
    }

    const reset = ({ filterPopup }) => {
        setController((prev) => ({
            ...prev,
            page: prev.searchPage ?? prev.page,
            searchPage: null,
        }));

        setFilter((prev) => ({
            ...prev,
            search: "",
            disable_button: true,
            ...(filterPopup && { startDate: null, endDate: null, }),
        }));

        filterPopup && handleClickFilter();
    };
    const handlePagination = (obj) => {
        setController(obj)
    }
    const handleOpenModal = (type, data = null) => {

        setOpenModal((prev) => ({
            ...prev,
            data: data,
            [type]: true,
        }));

    };

    const handleClosedModal = (type) => {

        setOpenModal((pre) => ({
            ...pre,
            data: null,
            [type]: false
        }))
    }
    return {
        loader,
        TableHeaderData,
        totalCount,
        controller,
        bookingList,
        filtermodal,
        Filter,
        openModal,
        handleClosedModal,
        handleOpenModal,
        handlePagination,
        handleClickFilter,
        handleChangeFilter,
        HandleSearch,
        reset,
    }


}